import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function ComparisonChart() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const data = [{
    name: 'Competitor C',
    value: 12.5,
    color: 'bg-red-500'
  }, {
    name: 'Competitor B',
    value: 15.8,
    color: 'bg-red-500'
  }, {
    name: 'Competitor A',
    value: 22.3,
    color: 'bg-red-500'
  }, {
    name: 'Phoenix Landscaper',
    value: 39.75,
    color: 'bg-gradient-to-t from-emerald-500 to-emerald-400',
    highlight: true
  }];
  return <section className="py-24 bg-white" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="text-center mb-16" data-id="element-64">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-65">
            Phoenix Landscaper vs. Their Competitors
          </h2>
          <p className="text-xl text-slate-600" data-id="element-66">
            Lead Conversion Rate Comparison
          </p>
        </div>

        <div ref={ref} className="max-w-4xl mx-auto h-96 flex items-end justify-center gap-4 md:gap-12 pb-12 border-b border-slate-200" data-id="element-67">
          {data.map((item, index) => <div key={item.name} className="flex flex-col items-center justify-end h-full w-full max-w-[120px] group" data-id="element-68">
              <div className="mb-3 text-center" data-id="element-69">
                <motion.span initial={{
              opacity: 0
            }} animate={isInView ? {
              opacity: 1
            } : {
              opacity: 0
            }} transition={{
              delay: 0.5 + index * 0.1
            }} className={`text-lg md:text-2xl font-bold ${item.highlight ? 'text-emerald-600' : 'text-red-500'}`} data-id="element-70">
                  {item.value}%
                </motion.span>
              </div>
              <motion.div initial={{
            height: 0
          }} animate={isInView ? {
            height: `${item.value / 45 * 100}%`
          } : {
            height: 0
          }} transition={{
            duration: 1,
            delay: index * 0.1,
            ease: 'easeOut'
          }} className={`w-full rounded-t-lg ${item.color} relative group-hover:opacity-90 transition-opacity`} data-id="element-71" />
              <p className={`mt-4 text-sm md:text-base font-medium text-center ${item.highlight ? 'text-slate-900 font-bold' : 'text-slate-500'}`} data-id="element-72">
                {item.name}
              </p>
            </div>)}
        </div>
        <p className="text-center text-sm text-slate-400 mt-6" data-id="element-73">
          Data source: Yelp Performance Analytics, 6-month period
        </p>
      </div>
    </section>;
}